import { Card, Typography } from "@mui/material";
import React from "react";

const RequestedFitting = () => {
  return (
    <>
      <Card sx={{ margin: "1em" }}>
        <Typography>
          To start the fitting please click the link we send to you via email.
        </Typography>
      </Card>
    </>
  );
};
export default RequestedFitting;
